module.exports = __webpack_public_path__ + "static/media/no.47353c32.svg";